import React from 'react'
import ButtonNew from 'presentation/shared/components/ButtonNew'
import CardNew from 'presentation/shared/components/CardNew'
import DividerNew from 'presentation/shared/components/DividerNew'
import HeadingNew from 'presentation/shared/components/HeadingNew'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import * as S from './styles'
import { ReactComponent as PlusIcon } from 'presentation/assets/icons/plus.svg'

type AddItemButtonProps = {
  onClick?: () => void
  label: string
}

export const AddItemButton = ({ onClick, label }: AddItemButtonProps) => (
  <S.AddButton>
    <ButtonNew
      outlined
      onClick={onClick}
      variant="text"
      icon={<PlusIcon />}
      fontSize="xsmall"
      noPadding
    >
      {label}
    </ButtonNew>
  </S.AddButton>
)

type EmptyListStateProps = {
  message: string
  showAddButton?: boolean
  onAdd?: () => void
  addLabel?: string
}

export const EmptyListState = ({
  message,
  showAddButton = false,
  onAdd,
  addLabel = ''
}: EmptyListStateProps) => (
  <CardNew
    background="neutral25"
    padding="1rem"
    style={{ borderRadius: '8px' }}
  >
    <SupportTextNew
      size="xxsmall"
      weight="black"
      color="textSecondary"
      as="div"
      style={{ textAlign: 'center' }}
    >
      {message}
    </SupportTextNew>

    {showAddButton && <AddItemButton onClick={onAdd} label={addLabel} />}
  </CardNew>
)

type SectionHeaderProps = {
  title: string
}

export const SectionHeader = ({ title }: SectionHeaderProps) => (
  <>
    <HeadingNew
      size="xxsmall"
      weight="black"
      color="textSecondary"
      as="div"
      style={{ marginLeft: '1.75rem' }}
    >
      {title}
    </HeadingNew>
    <DividerNew marginTop="0.25rem" marginBottom="0.5rem" />
  </>
)
